import type {
  CalidadPublic,
  ContenidoPublic,
  EmbudoPublic,
  MetricasPublic,
  RecontactoPublic,
} from '@app/shared';

import { api } from '../../../lib/api';

export const metricasApi = {
  async obtener(params: { desde?: string; hasta?: string; campana?: string }): Promise<MetricasPublic> {
    const { data } = await api.get<MetricasPublic>('/metricas', {
      params: {
        ...(params.desde ? { desde: params.desde } : {}),
        ...(params.hasta ? { hasta: params.hasta } : {}),
        ...(params.campana ? { campana: params.campana } : {}),
      },
    });
    return data;
  },
  async recontacto(): Promise<RecontactoPublic> {
    const { data } = await api.get<RecontactoPublic>('/metricas/recontacto');
    return data;
  },
  async embudo(params: { desde?: string; hasta?: string; campana?: string }): Promise<EmbudoPublic> {
    const { data } = await api.get<EmbudoPublic>('/metricas/embudo', {
      params: {
        ...(params.desde ? { desde: params.desde } : {}),
        ...(params.hasta ? { hasta: params.hasta } : {}),
        ...(params.campana ? { campana: params.campana } : {}),
      },
    });
    return data;
  },
  /** ciclo-calidad-leads (R7): calidad y costo por lead bueno, por anuncio y por campaña. */
  async calidad(params: { desde?: string; hasta?: string; campana?: string }): Promise<CalidadPublic> {
    const { data } = await api.get<CalidadPublic>('/metricas/calidad', {
      params: {
        ...(params.desde ? { desde: params.desde } : {}),
        ...(params.hasta ? { hasta: params.hasta } : {}),
        ...(params.campana ? { campana: params.campana } : {}),
      },
    });
    return data;
  },
  async contenido(params: { desde?: string; hasta?: string }): Promise<ContenidoPublic> {
    const { data } = await api.get<ContenidoPublic>('/metricas/contenido', {
      params: {
        ...(params.desde ? { desde: params.desde } : {}),
        ...(params.hasta ? { hasta: params.hasta } : {}),
      },
    });
    return data;
  },
};
